import React, { useContext, useEffect, useState } from "react"
import { useSelector } from "react-redux";
import { useCookies } from "react-cookie";
import classNames from "classnames";
import { Module } from "Components/Module"
import { Close } from "Components/Icons";
import { Button } from "Components/ReactstrapSlim";
import { IReservationMemberViewModel, PortalClient } from "Services/API/API";
import useMediaBreakpointDown from "Hooks/useMediaBreakpointDown";
import { useApiClient } from "Services/API/useApiClient";
import { socialActivityEnabledSelector } from "Utils/selectors";
import { AvatarCircle } from "Components/AvatarCircle";
import AccountContext from "../../AccountContext";

interface SocialBannerProps {
}

const SOCIAL_ACTIVITY_BANNER_COOKIE_NAME = "sa_banner";
const SOCIAL_ACTIVITY_BANNER_DISABLED_COOKIE_NAME = "sa_banner_disabled";

export const SocialBanner: React.FC<SocialBannerProps> = function() {
    const [colleagues, setColleagues] = useState<IReservationMemberViewModel[]>([]);
    const portalClient = useApiClient(PortalClient);
    const account = useContext(AccountContext);
    const [cookies, setCookie] = useCookies([SOCIAL_ACTIVITY_BANNER_COOKIE_NAME, SOCIAL_ACTIVITY_BANNER_DISABLED_COOKIE_NAME]);
    const isMobile = useMediaBreakpointDown("xs");
    const socialActivityEnabled = useSelector(socialActivityEnabledSelector);
    const [isLoading, setIsLoading] = useState(false);

    const isVisible = () => !cookies[SOCIAL_ACTIVITY_BANNER_COOKIE_NAME] || (cookies[SOCIAL_ACTIVITY_BANNER_COOKIE_NAME] < 3 && !cookies[SOCIAL_ACTIVITY_BANNER_DISABLED_COOKIE_NAME])
    
    const onClose = () => {
        if (!cookies[SOCIAL_ACTIVITY_BANNER_COOKIE_NAME]) {
            setCookie(SOCIAL_ACTIVITY_BANNER_COOKIE_NAME, 1);
        } else {
            setCookie(SOCIAL_ACTIVITY_BANNER_COOKIE_NAME, +cookies[SOCIAL_ACTIVITY_BANNER_COOKIE_NAME] + 1);
        }
        const date = new Date();
        const days = 7;
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        setCookie(SOCIAL_ACTIVITY_BANNER_DISABLED_COOKIE_NAME, true, { expires: date });
    }

    const loadColleagues = async () => {
        if (socialActivityEnabled && isVisible()) {
            try {
                setIsLoading(true);
                const data = await portalClient.getColleaguesNearBy(account.id);
                setColleagues(data);
            } catch(exc) {
                console.log(exc);
            } finally {
                setIsLoading(false);
            }
        }
    }

   const onLinkClick = (e: React.MouseEvent) => {
        e.preventDefault();
        const selectedElement = document.getElementById("social-activity-id");
        if (selectedElement) {
            const position = selectedElement.getBoundingClientRect().top + window.pageYOffset - 64;
            window.scrollTo({
                top: position,
                behavior: "smooth"
             });
        }
    }

    useEffect(() => {
        loadColleagues();
    }, []);

    return <>{ socialActivityEnabled && isVisible() && (isLoading || colleagues.length > 0) && <Module className="social-banner-module" size="lg" loading={isLoading}>
        <div className="banner-wrapper">
            <div className="coworkers-wrapper">
                <div className="guest-avatar-list-wrapper">
                    <div className="guest-avatar-list">
                    {
                        colleagues.slice(0, 3).map((colleague, index) => <AvatarCircle key={index} colorIndex={index} {...colleague}/>)
                    }
                    </div>
                    { isMobile && <CloseButton onClose={onClose} /> }
                </div>
                <div className="info-wrapper">
                    <div className="title">You have coworkers nearby</div>
                    <div className="subtitle">See where your {account.name} coworkers are working nearby and join them.</div>
                </div>
            </div>
            <div className="action-wrapper">
                <div>
                    <a href="#" onClick={onLinkClick}>View coworkers nearby</a>
                </div>
                { !isMobile && <CloseButton onClose={onClose} /> }
            </div>
        </div>
    </Module> }</>
}

interface CloseBtnProps {
    onClose: () => void,
    className?: string
}

const CloseButton: React.FC<CloseBtnProps> = ({onClose, className}) => {
    return <div className={classNames("close-wrapper", className)}>
        <Button size="sm" color="link" className="p-px8">
            <Close style={{ color: "#C0CAD8" }} onClick={onClose} />
        </Button>
    </div>
}